import { useContext } from 'react';

import { AlertContext } from './';

export const useAlert = () => {
  const { addAlert, alert, removeAlert } = useContext(AlertContext);
  return { addAlert, alert, removeAlert };
};
